<template>
  <div class="elfsight-app-dfc6d54b-9164-4556-a152-ebdfcba892df" data-elfsight-app-lazy />
</template>

<script>
export default {
  name: 'WidgetReview',
  mounted() {
    // Load the Elfsight widget script dynamically
    const script = document.createElement('script');
    script.src = 'https://apps.elfsight.com/p/platform.js';
    script.async = true;
    script.onload = () => {
      // Initialize the widget after the script has loaded
      if (window.ElfsightWidgets) {
        window.ElfsightWidgets.init();
      }
    };
    document.head.appendChild(script);
  },
};
</script>
